import { axiosInstance } from "../instance";

export const fetchData = (url, method, body, headers) => {
  return axiosInstance[method](url, body, headers);
};
